module.exports = __webpack_public_path__ + "img/card01.ad3198ac.png";